import { FETCH_NOTIFICATION_SOURCES } from '@/pages/SpaceNotificationSourcesPage/actionTypes'
import { AppThunk } from '@/store'
import { request } from '@/store/actions'

import {
  DELETE_NOTIFICATION,
  FETCH_NOTIFICATION,
  FETCH_NOTIFICATIONS_PAGINATED,
  RECALL_NOTIFICATION
} from './actionTypes'

export const fetchNotificationSources = (): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        '',
        FETCH_NOTIFICATION_SOURCES,
        {
          method: 'GET',
          headers: { 'x-workgrid-space': ':spaceId' }
        },
        {
          args: { spaceId: ':spaceId' },
          service: 'notificationSources'
        }
      )
    )
  }
}

// V2
// TODO Stop using redux
export function deleteMultilingualNotification(notificationId: string): AppThunk {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/spaces/:spaceId/notifications/${notificationId}`,
        DELETE_NOTIFICATION,
        { method: 'DELETE' },
        { args: { notificationId }, service: 'publisherV2' }
      )
    )
  }
}

export function fetchMultilingualNotificationById(notificationId: string): AppThunk {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/spaces/:spaceId/notifications/${notificationId}`,
        FETCH_NOTIFICATION,
        {
          headers: {
            'x-workgrid-accept-encoding': 'workgrid-gzip'
          }
        },
        { args: { notificationId }, service: 'publisherV2' }
      )
    )
  }
}

export function fetchMultilingualNotificationsPaginated(query: any): AppThunk {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/spaces/:spaceId/search`,
        FETCH_NOTIFICATIONS_PAGINATED,
        { method: 'POST', body: query },
        { service: 'publisherV2' }
      )
    )
  }
}

export function recallMultilingualNotification(notificationId: string): AppThunk {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/spaces/:spaceId/notifications/${notificationId}/recall`,
        RECALL_NOTIFICATION,
        { method: 'PUT' },
        { args: { notificationId }, service: 'publisherV2' }
      )
    )
  }
}
